/* eslint-disable max-len */
import { triggerEvent } from 'utilities/dom';

/**
 *
 * Send cart actions data to Tealium
 * @param {object} trackingParams - Google Analytics tracking object (required)
 */

function trackCartActions (trackingParams) {

	if (!trackingParams) {

		throw new Error('Cart Action Tracking Validation Error: missing parameter - tracking object');

	}

	if (!trackingParams.event_action) {

		throw new Error(
			'Cart Action Tracking Validation Error: missing required property in tracking object "event_action"'
		);

	}

	const trackingDefaults = {
		event_category: 'Cart'
	};
	const trackingData = {
		...trackingDefaults,
		...trackingParams
	};

	// trigger global event for Tealium
	triggerEvent.call(window.top.document, 'tracking:cart', trackingData);

}

export default trackCartActions;
